function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 35,
    viewBox: "0 0 140 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M61.8 34.2H50.5c-2.4 0-4.4-.6-5.8-1.8-1.4-1.2-2.1-2.9-2.1-5.1V17.2c0-2.2.7-3.9 2.1-5.1s3.3-1.8 5.8-1.8H55c2.4 0 4.4.6 5.7 1.8 1.4 1.2 2.1 2.9 2.1 5.1v6c0 .5-.2.7-.7.7H47c-.4 0-.5.1-.5.4v2.9c0 2.7 1.5 4.1 4.5 4.1h10.9c.5 0 .7.2.7.7v1.7c0 .3-.3.5-.8.5ZM47 21.4h11.5c.4 0 .5-.2.5-.5v-3.6c0-2.7-1.5-4-4.5-4H51c-3 0-4.5 1.3-4.5 4v3.6c0 .3.2.5.5.5Zm25.5 12.8h-2.4c-.5 0-.7-.2-.7-.7V10.9c0-.4.2-.7.7-.7h2.4c.5 0 .7.2.7.7v1.8h.2c.9-1.7 2.7-2.5 5.4-2.5h3c2.4 0 4.3.6 5.6 1.8 1.3 1.2 2 2.9 2 5.1v16.4c0 .4-.2.7-.7.7h-2.4c-.5 0-.7-.2-.7-.7V17.3c0-2.7-1.5-4.1-4.5-4.1h-3c-1.6 0-2.8.4-3.7 1.1-.9.8-1.3 1.8-1.3 3.2v16c.2.5-.1.7-.6.7Zm22.1-24h2.5c.5 0 .7.2.9.7l6.4 19.9h.3l6.3-19.9c.1-.4.4-.7.9-.7h2.5c.5 0 .7.2.5.7l-7.7 22.6c-.1.5-.4.7-1 .7h-3.6c-.5 0-.8-.2-1-.7L94 10.9c-.1-.5.1-.7.6-.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1.5c2.1 0 3.8 1.7 3.8 3.7s-1.7 3.7-3.8 3.7-3.8-1.7-3.8-3.7S28 .5 30.1.5ZM1.3 7.9h18.9c.4 0 .8-.3.8-.7v-6c0-.4-.3-.7-.8-.7H1.3C.9.5.5.8.5 1.2v5.9c0 .5.3.8.8.8ZM8 33.7V14.3c0-.3-.3-.6-.6-.6H1.1c-.3 0-.6.3-.6.6v19.4c0 .3.3.6.6.6h6.3c.4 0 .6-.3.6-.6Zm6.1.6h19.1c.4 0 .7-.3.7-.7v-6.1c0-.4-.3-.7-.7-.7H14.1c-.4 0-.7.3-.7.7v6.1c0 .4.3.7.7.7Zm12.2-16.9c0 2 1.7 3.7 3.8 3.7s3.8-1.7 3.8-3.7-1.7-3.7-3.8-3.7-3.8 1.7-3.8 3.7Zm-12.9 0c0 2 1.7 3.7 3.8 3.7s3.8-1.7 3.8-3.7-1.7-3.7-3.8-3.7-3.8 1.7-3.8 3.7Z",
    style: {
      fill: "#00edb9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.9 3.4C135 1.8 132.5 1 129.5 1c-3.4 0-6.2 1.1-7.8 3.1-1.5 1.8-2 3.8-2 8.1V23c0 5 .5 6.8 2.2 8.7 1.8 1.9 4.5 2.9 7.7 2.9s5.8-.9 7.6-2.8c1.7-1.7 2.4-4 2.4-7.7V11c-.1-3.9-.8-5.8-2.7-7.6ZM123.4 12c0-3 .2-4.1 1.1-5.4 1-1.6 2.9-2.5 5.2-2.5 1.7 0 3.3.6 4.4 1.6.4.4.7.7.9 1.1l-11.6 18.9V12Zm12.4 12c0 2.5-.3 3.9-1.1 5.1-1 1.4-3 2.2-5.1 2.2-2 0-3.9-.8-4.9-2-.1-.1-.2-.2-.3-.4l11.4-18.6V24Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.6f6721d359f2dfaae90eea070c945475.svg";
export { ForwardRef as ReactComponent };